import api from '../axios'

export default {
  create(data) {
    return api.post(`/ventas`, data);
  },
  getAll(){
    return api.get(`/getSales`);
  }
};
